import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../utils/axiosInstance';

const SpecialPaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // If you want to verify the session id from the URL parameters
        const searchParams = new URLSearchParams(location.search);
        const sessionId = searchParams.get('session_id');

        if (sessionId) {
            console.log('Payment completed via Stripe Session:', sessionId);
            // The Stripe Webhook is already handling the database updates!
        }
    }, [location]);

    return (
        <div className='flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6'>
            <div className='bg-white p-10 rounded-2xl shadow-lg max-w-md text-center'>
                <div className='text-green-500 mb-6'>
                    {/* Checkmark Icon */}
                    <svg className='w-20 h-20 mx-auto' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                        <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                        ></path>
                    </svg>
                </div>
                <h1 className='text-3xl font-bold text-gray-800 mb-2'>Payment Successful!</h1>
                <p className='text-gray-600 mb-8'>
                    Your Special Package is now actively running. Our team will begin the driver matching process.
                </p>

                <button
                    onClick={() => navigate('/carrier/package')}
                    className='bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg hover:bg-blue-700 w-full'
                >
                    Return to Dashboard
                </button>
            </div>
        </div>
    );
};

export default SpecialPaymentSuccess;
